module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cockpit/component/cockpit/bulk-renewal-proposal/bulk-renewal-proposal.scss
// module id = ./src/app/cockpit/component/cockpit/bulk-renewal-proposal/bulk-renewal-proposal.scss
// module chunks = main